module.exports = __webpack_public_path__ + "img/2.b4c65e14.jpg";